import { render } from "./commonAgreement.vue?vue&type=template&id=92e2f9ea"
import script from "./commonAgreement.vue?vue&type=script&lang=js"
export * from "./commonAgreement.vue?vue&type=script&lang=js"

import "./commonAgreement.vue?vue&type=style&index=0&id=92e2f9ea&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__